export { DMS_MODULE } from '../constants';
export const NAME = 'InventoryAdjustment';
export const API_NAME = 'InventoryAdjustment';
export const EXPORT_FILE_NAME = 'InventoryAdjustmentReport.xlsx';
export const CRUMB_LABEL_KEY = 'InventoryAdjustment';

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
